

export default {
  // table 风格展示事项
  name: 'WkTableItems',

  components: {
    WkFormItem: function WkFormItem() {
      return import('../WkForm/WkFormItem');
    }
  },

  props: {
    // 表单验证前缀
    propPrefix: {
      type: String,
      default: ''
    },
    fieldFrom: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fieldList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: Boolean
  },

  data: function data() {
    return {};
  },


  computed: {},

  watch: {},

  created: function created() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {
    deleteClick: function deleteClick(index) {
      this.$emit('delete', index);
    },
    getMinWidth: function getMinWidth(formType) {
      if (formType === 'date_interval' || formType === 'dateRange' || formType === 'file' || formType === 'location' || formType === 'position') {
        return 250;
      }
      return 150;
    },


    /**
     * 判断展示
     */
    getShowValue: function getShowValue(item) {
      if (item.hasOwnProperty('show')) {
        return item.show;
      }
      return true;
    },


    /**
     * 字段change
     */
    fieldChange: function fieldChange(item, index, value, valueList) {
      this.$emit('change', item, index, value, valueList);
    }
  }
};